export const ROUTE = {
  HOME: '/'
}
